import styled from 'styled-components';
import mediaQuery from 'styles/mediaQuery';

export const TriggerConditionsContainer = styled.div`
  align-items: start;
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-bottom: 15px;
  padding-left: 15px;
  padding-right: 15px;

  .condition-row {
    align-items: start;
    display: flex;
    flex-direction: row;
    gap: 5px;
    width: 100%;

    .remove-condition {
      border: none;
    }
  }

  .condition-row__fields {
    align-items: start;
    display: flex;
    flex-direction: row;
    gap: 5px;

    ${mediaQuery.xs} {
      flex-wrap: wrap;
    }

    &.condition-row__fields--space-between {
      justify-content: space-between;
      width: 100%;
    }

    select,
    .basic-multi-select {
      min-width: 100px;
    }

    .form-field-container {
      margin-bottom: 0;

      > div {
        padding-left: 0;
        padding-right: 0;
      }
    }

    .select__dropdown-indicator {
      padding: 6px;
    }
  }

  .condition-help-text {
    margin-top: 7px;
  }
`;
